import { AccessTime } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { formatDistance, parseISO } from 'date-fns';
import * as React from 'react';

export type TimeInNaqIndicatorProps = {
  enteredAt: string | Date;
};

function toDate(value: string | Date): Date {
  if (value instanceof Date) {
    return value;
  }
  return parseISO(value);
}

function computeLabel(value: string | Date): string {
  const entered = toDate(value);
  if (Number.isNaN(entered.getTime())) {
    return 'in NAQ for unknown duration';
  }
  return `in NAQ for ${formatDistance(entered, new Date(), {
    addSuffix: false,
  })}`;
}

export function TimeInNaqIndicator({ enteredAt }: TimeInNaqIndicatorProps) {
  const [label, setLabel] = React.useState<string>(() =>
    computeLabel(enteredAt)
  );

  React.useEffect(() => {
    setLabel(computeLabel(enteredAt));
    const intervalId = window.setInterval(() => {
      setLabel(computeLabel(enteredAt));
    }, 60_000);
    return () => {
      window.clearInterval(intervalId);
    };
  }, [enteredAt]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      data-testid="time-in-naq-indicator"
    >
      <AccessTime fontSize="small" />
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    </Stack>
  );
}
